(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireda84"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireda84"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

var $d09e1d0ba9b488aa$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("hyeyu"), JSON.parse('["hyeyu","main.js","lzMlY","../pin.17ac4448.svg","9dxTN","../cluster-pin.5df8d604.svg"]'));

class $90df0591fe51bcf3$export$2e2bcd8739ae039 {
    /**
	 *
	 * @type {Array<{element: HTMLElement, module: Object}>}
	 */ #holders = [];
    /**
	 *
	 * @param {Array<Object>} modules
	 */ constructor(modules){
        for (const module of modules)this.#holders = this.#holders.concat(module.getHolderSelectors().flatMap((selector)=>[
                ...document.querySelectorAll(selector)
            ]).map((holder)=>Object.create({
                element: holder,
                module: module
            })));
        document.addEventListener("dependency-chain:loaded", this.#createReadyModules.bind(this));
        this.#createReadyModules();
    }
    #createReadyModules() {
        for (const holder of this.#holders)if (holder.element.dataset.module === "ready") {
            new holder.module(holder.element);
            holder.element.dataset.module = "created";
        }
    }
}


/**
 * A lightweight alternative to using moment.js
 *
 * No Dependencies
 */ class $c919c3c258b76ce3$export$2e2bcd8739ae039 {
    static DAYS_OF_WEEK = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    static MONTHS = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    static ISO_8601 = "yyyy-mm-dd";
    static COMPACT = "dd/mm/yy";
    static NICE = "d mmm yyyy";
    static OFFERS = "dddd mmm yyyy";
    static CALENDAR = "dd mmmm, yyyy";
    /**
	 * @param {Date} date
	 * @param {String} format
	 * @return {String}
	 */ static format(date, format) {
        switch(format){
            case $c919c3c258b76ce3$export$2e2bcd8739ae039.ISO_8601:
                return [
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getYear(date, "yyyy"),
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getMonth(date, "mm"),
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getDate(date, "dd")
                ].join("-");
            case $c919c3c258b76ce3$export$2e2bcd8739ae039.COMPACT:
                return [
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getDate(date, "dd"),
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getMonth(date, "mm"),
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getYear(date, "yy")
                ].join("/");
            case $c919c3c258b76ce3$export$2e2bcd8739ae039.NICE:
                return [
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getDate(date, "d"),
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getMonth(date, "mmm"),
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getYear(date, "yyyy")
                ].join(" ");
            case $c919c3c258b76ce3$export$2e2bcd8739ae039.OFFERS:
                return [
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getDate(date, "dddd") + ",",
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getMonth(date, "mmm"),
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getYear(date, "yyyy")
                ].join(" ");
            case $c919c3c258b76ce3$export$2e2bcd8739ae039.CALENDAR:
                return [
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getDate(date, "dd"),
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getMonth(date, "mmmm") + ",",
                    $c919c3c258b76ce3$export$2e2bcd8739ae039.#getYear(date, "yyyy")
                ].join(" ");
        }
    }
    /**
	 * @param {Date} date1
	 * @param {Date} date2
	 * @return {Number}
	 */ static nights(date1, date2) {
        const oneDay = 86400000;
        return Math.floor((date1 - date2) / oneDay);
    }
    /**
	 * @param {Date} date
	 * @param {Number} amount
	 * @returns {Date}
	 */ static addDays(date, amount) {
        const newDate = new Date(+date);
        newDate.setDate(newDate.getDate() + amount);
        return newDate;
    }
    /**
	 * @param {Date} date
	 * @param {Number} amount
	 * @returns {Date}
	 */ static subtractDays(date, amount) {
        const newDate = new Date(+date);
        newDate.setDate(newDate.getDate() - amount);
        return newDate;
    }
    /**
	 * @param {Date} date
	 * @param {String} format
	 * @return {String}
	 */ static #getYear(date, format) {
        if (format === "yy") return (date.getFullYear() + "").slice(2);
        else return date.getFullYear() + "";
    }
    /**
	 * @param {Date} date
	 * @param {String} format
	 * @return {String}
	 */ static #getMonth(date, format) {
        switch(format){
            case "m":
                return date.getMonth() + 1 + "";
            case "mm":
                return date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1 + "";
            case "mmm":
                return $c919c3c258b76ce3$export$2e2bcd8739ae039.MONTHS[date.getMonth()].slice(0, 3);
            case "mmmm":
                return $c919c3c258b76ce3$export$2e2bcd8739ae039.MONTHS[date.getMonth()];
            default:
                return $c919c3c258b76ce3$export$2e2bcd8739ae039.MONTHS[date.getMonth()];
        }
    }
    /**
	 * @param {Date} date
	 * @param {String} format
	 * @return {String}
	 */ static #getDate(date, format) {
        switch(format){
            case "d":
                return date.getDate() + "";
            case "dd":
                return date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + "";
            case "ddd":
                return $c919c3c258b76ce3$export$2e2bcd8739ae039.DAYS_OF_WEEK[date.getDay()].slice(0, 3);
            case "dddd":
                return $c919c3c258b76ce3$export$2e2bcd8739ae039.DAYS_OF_WEEK[date.getDay()];
            default:
                return $c919c3c258b76ce3$export$2e2bcd8739ae039.DAYS_OF_WEEK[date.getDay()];
        }
    }
    /**
	 * @param {Date|String} date
	 */ static isValid(date) {
        if (date === "Invalid Date") return false;
        return date.valueOf() !== 0;
    }
    static isValidCheckOut(checkIn, checkOut) {
        const minDate = $c919c3c258b76ce3$export$2e2bcd8739ae039.addDays(checkIn, 1);
        return minDate <= checkOut;
    }
}


class $b5900b0d33e64e2a$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            "header"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @type {Pikaday} */ #checkInDatePicker;
    /** @type {Pikaday} */ #checkOutDatePicker;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        this.#setNavBar();
        this.#setSideMenu();
        this.#setBooking();
        this.#holderElement.querySelector(".overlay").addEventListener("click", (e)=>{
            this.#closeSideMenu(e);
            this.#closeBooking(e);
        });
    }
    #setNavBar() {
        if (!document.querySelector(".hero-element") && !document.querySelector(".room-nav-bar-element")) document.querySelector(".header-position-holder").style.height = this.#holderElement.offsetHeight / 16 + "rem";
        if (document.querySelector(".room-nav-bar-element")) this.#holderElement.style.position = "initial";
        this.#holderElement.querySelectorAll(".btn-menu-col").forEach((menuIcon)=>{
            menuIcon.addEventListener("click", ()=>{
                menuIcon.querySelector(".menu-icon").classList.toggle("open");
            });
        });
    }
    #setSideMenu() {
        this.#holderElement.querySelector(".btn-side-menu").addEventListener("click", (e)=>{
            this.#openSideMenu(e);
        });
        this.#holderElement.querySelector(".close-side-menu").addEventListener("click", (e)=>{
            this.#closeSideMenu(e);
        });
    }
    #setBooking() {
        const arrivalInput = this.#holderElement.querySelector('[name="checkInDate"]');
        const departureInput = this.#holderElement.querySelector('[name="checkOutDate"]');
        this.#holderElement.querySelectorAll(".btn-booking").forEach((btnBooking)=>{
            btnBooking.addEventListener("click", (e)=>{
                this.#openBooking(e);
            });
        });
        this.#holderElement.querySelector(".close-booking").addEventListener("click", (e)=>{
            this.#closeBooking(e);
        });
        let checkInField = this.#holderElement.querySelector(".check-in-field");
        let checkOutField = this.#holderElement.querySelector(".check-out-field");
        this.#checkInDatePicker = new Pikaday({
            field: checkInField,
            minDate: new Date(),
            onSelect: (date)=>{
                checkInField.value = (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).format(date, (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).CALENDAR);
                checkInField.dataset.date = (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).format(date, (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).ISO_8601);
                arrivalInput.value = (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).format(date, (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).ISO_8601);
                if (this.#checkOutDatePicker.getDate() < this.#checkInDatePicker.getDate()) this.#checkOutDatePicker.setDate((0, $c919c3c258b76ce3$export$2e2bcd8739ae039).addDays(date, 2));
            }
        });
        this.#checkOutDatePicker = new Pikaday({
            field: checkOutField,
            minDate: new Date(),
            onSelect: (date)=>{
                checkOutField.value = (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).format(date, (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).CALENDAR);
                checkOutField.dataset.date = (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).format(date, (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).ISO_8601);
                if (!arrivalInput.value) return;
                departureInput.value = (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).format(date, (0, $c919c3c258b76ce3$export$2e2bcd8739ae039).ISO_8601);
            }
        });
        this.#checkInDatePicker.setDate(new Date());
        this.#checkOutDatePicker.setDate((0, $c919c3c258b76ce3$export$2e2bcd8739ae039).addDays(new Date(), 2));
        let bookingSwitchTab = this.#holderElement.querySelector(".booking-switch-tab");
        bookingSwitchTab.querySelector(".today").addEventListener("click", ()=>{
            this.#handleTabSelection(bookingSwitchTab.querySelector(".today"));
            this.#checkInDatePicker.setDate(new Date());
            this.#checkOutDatePicker.setDate((0, $c919c3c258b76ce3$export$2e2bcd8739ae039).addDays(new Date(), 2));
        });
        bookingSwitchTab.querySelector(".tomorrow").addEventListener("click", ()=>{
            this.#handleTabSelection(bookingSwitchTab.querySelector(".tomorrow"));
            this.#checkInDatePicker.setDate((0, $c919c3c258b76ce3$export$2e2bcd8739ae039).addDays(new Date(), 1));
            this.#checkOutDatePicker.setDate((0, $c919c3c258b76ce3$export$2e2bcd8739ae039).addDays(new Date(), 3));
        });
        bookingSwitchTab.querySelector(".weekend").addEventListener("click", ()=>{
            let today = new Date();
            let day = today.getDay();
            let saturday;
            let sunday = new Date();
            if (day === 0 || day === 6) {
                saturday = today;
                sunday.setDate(saturday.getDate() + (day === 0 ? 0 : 1));
            } else {
                saturday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 6 - day);
                sunday.setDate(saturday.getDate() + (saturday.getDay() === 0 ? 0 : 1));
            }
            this.#handleTabSelection(bookingSwitchTab.querySelector(".weekend"));
            this.#checkInDatePicker.setDate(saturday);
            this.#checkOutDatePicker.setDate(sunday);
        });
        let hiddenField = this.#holderElement.querySelector(".booking-form-hidden");
    // this.#holderElement.querySelector('.submit').addEventListener('click', (e) => {
    // 	e.preventDefault();
    // 	hiddenField.innerHTML = '';
    //
    // 	this.#holderElement.querySelector('.booking-form').querySelectorAll('.field').forEach(field => {
    // 		let key = field.getAttribute('name').toLowerCase();
    // 		let value;
    //
    // 		if (field.classList.contains('date-picker')) {
    // 			value = field.dataset.date;
    // 		} else if (field.classList.contains('quantity')) {
    // 			value = field.value;
    // 		}
    // 		hiddenField.innerHTML += `<input type="hidden" name="` + key + `" value="` + value + `">`;
    // 	});
    //
    // 	hiddenField.submit();
    // });
    }
    /** @param {HTMLElement} element */ #handleTabSelection(element) {
        this.#holderElement.querySelector(".booking-switch-tab").querySelector(".active").classList.remove("active");
        element.classList.add("active");
    }
    /** @param {Event} e */ #openSideMenu(e) {
        e.preventDefault();
        this.#holderElement.querySelector(".side-menu").classList.add("show");
        this.#holderElement.querySelector(".overlay").style.visibility = "visible";
        this.#holderElement.querySelector(".overlay").style.opacity = 1;
        document.querySelector("body").style.overflow = "hidden";
    }
    /** @param {Event} e */ #closeSideMenu(e) {
        e.preventDefault();
        this.#holderElement.querySelector(".side-menu").classList.remove("show");
        this.#holderElement.querySelector(".overlay").style.visibility = "hidden";
        this.#holderElement.querySelector(".overlay").style.opacity = 0;
        document.querySelector("body").style.overflow = "unset";
    }
    /** @param {Event} e */ #openBooking(e) {
        e.preventDefault();
        this.#holderElement.querySelector(".booking").classList.add("show");
        this.#holderElement.querySelector(".overlay").style.visibility = "visible";
        this.#holderElement.querySelector(".overlay").style.opacity = 1;
        document.querySelector("body").style.overflow = "hidden";
    }
    /** @param {Event} e */ #closeBooking(e) {
        e.preventDefault();
        this.#holderElement.querySelector(".booking").classList.remove("show");
        this.#holderElement.querySelector(".overlay").style.visibility = "hidden";
        this.#holderElement.querySelector(".overlay").style.opacity = 0;
        document.querySelector("body").style.overflow = "unset";
    }
}


class $02951e8ab9437aa9$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            "footer"
        ];
    /** @type {HTMLElement} */ #element;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#element = holderElement;
        if (holderElement.dataset.instagram) this.#loadInstagram();
    }
    async #loadInstagram() {
        const baseUrl = `/instagram/${this.#element.dataset.instagram}`;
        const feedUrl = `${baseUrl}/feed.json`;
        const response = await fetch(feedUrl);
        if (!response.ok) {
            console.warn(`Could not get Instagram feed. HTTP status: ${response.status}`);
            return;
        }
        const feed = await response.json();
        const slides = [];
        let count = 0;
        for (const filename of feed){
            if (count > 4) break;
            const img = document.createElement("img");
            img.src = `${baseUrl}/${filename}`;
            img.loading = "lazy";
            const li = document.createElement("li");
            li.classList.add("splide__slide");
            li.append(img);
            slides.push(li);
            count++;
        }
        this.#element.querySelector(".splide__list").append(...slides);
        const slider = new Splide(this.#element.querySelector(".splide"), {
            type: "loop",
            gap: "3.2rem",
            arrows: false,
            pagination: false,
            perPage: 3,
            breakpoints: {
                992: {
                    perPage: 2,
                    gap: "1rem"
                }
            }
        });
        slider.mount();
        const sliderControls = this.#element.querySelectorAll("[data-slider-control]");
        sliderControls.forEach((sliderControl)=>{
            sliderControl.addEventListener("click", ()=>{
                slider.go(sliderControl.dataset.sliderControl);
            });
        });
    }
}


class $125566076e2f0cd4$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".carousel-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        let self = this;
        let lastWindowSize = window.innerWidth;
        this.#setSplide();
        window.addEventListener("resize", function(event) {
            if (lastWindowSize < 768 && window.innerWidth >= 768 || lastWindowSize >= 768 && window.innerWidth < 768) {
                lastWindowSize = window.innerWidth;
                self.#setSplide();
            }
        }, true);
    }
    #setSplide() {
        if (window.innerWidth >= 768) new Splide(this.#holderElement.querySelector(".splide"), {
            type: "loop",
            perPage: 3,
            perMove: 1,
            gap: "1rem",
            pagination: false,
            arrows: true
        }).mount();
        else new Splide(this.#holderElement.querySelector(".splide"), {
            type: "loop",
            perPage: 1,
            perMove: 1,
            gap: "1rem",
            pagination: false,
            arrows: true
        }).mount();
    }
}


class $30d05a3b7b2a050e$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".large-card-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
    }
}


class $4712496a6aa399de$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".alternating-row-element"
        ];
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        const sliderElement = holderElement.querySelector(".splide");
        if (!sliderElement) return;
        const slider = new Splide(sliderElement, {
            type: "loop",
            gap: "1rem",
            perPage: 1,
            perMove: 1,
            pagination: false,
            arrows: false
        });
        slider.mount();
        const sliderControls = holderElement.querySelectorAll("[data-slider-control]");
        sliderControls.forEach((sliderControl)=>{
            sliderControl.addEventListener("click", ()=>{
                slider.go(sliderControl.dataset.sliderControl);
            });
        });
    }
}


class $93c45a678ea1b005$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".room-nav-bar-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        let self = this;
        document.querySelector(".room-nav-bar-position-holder").style.height = this.#holderElement.offsetHeight / 16 + "rem";
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(function(entries) {
                if (entries[0].isIntersecting) {
                    document.querySelector(".room-nav-bar-position-holder").style.display = "none";
                    self.#holderElement.classList.remove("scrolled");
                } else {
                    document.querySelector(".room-nav-bar-position-holder").style.display = "block";
                    self.#holderElement.classList.add("scrolled");
                }
            });
            if (document.querySelector("header")) observer.observe(document.querySelector("header"));
            else {
                document.querySelector(".room-nav-bar-position-holder").style.display = "block";
                this.#holderElement.classList.add("scrolled");
            }
        }
    }
}


class $85144a7bc83ca709$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".room-features-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        let self = this;
        if ("IntersectionObserver" in window) {
            const observer = new IntersectionObserver(function(entries) {
                if (entries[0].isIntersecting) self.#holderElement.classList.add("scrolled");
            });
            if (document.querySelector("header")) observer.observe(self.#holderElement);
        }
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ function $57fb306f6b148ac8$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $57fb306f6b148ac8$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
// do not edit .js files directly - edit src/index.jst
var $57fb306f6b148ac8$var$fastDeepEqual = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};
var $57fb306f6b148ac8$var$isEqual = /*@__PURE__*/ $57fb306f6b148ac8$var$getDefaultExportFromCjs($57fb306f6b148ac8$var$fastDeepEqual);
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $57fb306f6b148ac8$export$19fc78b4b5aa5d0d = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */ var $57fb306f6b148ac8$export$406cfe323c8bb8e4;
(function(LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})($57fb306f6b148ac8$export$406cfe323c8bb8e4 || ($57fb306f6b148ac8$export$406cfe323c8bb8e4 = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */ class $57fb306f6b148ac8$export$3b0d6d7590275603 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */ constructor({ apiKey: apiKey, authReferrerPolicy: authReferrerPolicy, channel: channel, client: client, id: id = $57fb306f6b148ac8$export$19fc78b4b5aa5d0d, language: language, libraries: libraries = [], mapIds: mapIds, nonce: nonce, region: region, retries: retries = 3, url: url = "https://maps.googleapis.com/maps/api/js", version: version }){
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || $57fb306f6b148ac8$export$19fc78b4b5aa5d0d; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if ($57fb306f6b148ac8$export$3b0d6d7590275603.instance) {
            if (!$57fb306f6b148ac8$var$isEqual(this.options, $57fb306f6b148ac8$export$3b0d6d7590275603.instance.options)) throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify($57fb306f6b148ac8$export$3b0d6d7590275603.instance.options)}`);
            return $57fb306f6b148ac8$export$3b0d6d7590275603.instance;
        }
        $57fb306f6b148ac8$export$3b0d6d7590275603.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy
        };
    }
    get status() {
        if (this.errors.length) return $57fb306f6b148ac8$export$406cfe323c8bb8e4.FAILURE;
        if (this.done) return $57fb306f6b148ac8$export$406cfe323c8bb8e4.SUCCESS;
        if (this.loading) return $57fb306f6b148ac8$export$406cfe323c8bb8e4.LOADING;
        return $57fb306f6b148ac8$export$406cfe323c8bb8e4.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     * @deprecated
     */ createUrl() {
        let url = this.url;
        url += `?callback=__googleMapsCallback&loading=async`;
        if (this.apiKey) url += `&key=${this.apiKey}`;
        if (this.channel) url += `&channel=${this.channel}`;
        if (this.client) url += `&client=${this.client}`;
        if (this.libraries.length > 0) url += `&libraries=${this.libraries.join(",")}`;
        if (this.language) url += `&language=${this.language}`;
        if (this.region) url += `&region=${this.region}`;
        if (this.version) url += `&v=${this.version}`;
        if (this.mapIds) url += `&map_ids=${this.mapIds.join(",")}`;
        if (this.authReferrerPolicy) url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) script.remove();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     * @deprecated, use importLibrary() instead.
     */ load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     * @deprecated, use importLibrary() instead.
     */ loadPromise() {
        return new Promise((resolve, reject)=>{
            this.loadCallback((err)=>{
                if (!err) resolve(window.google);
                else reject(err.error);
            });
        });
    }
    importLibrary(name) {
        this.execute();
        return google.maps.importLibrary(name);
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     * @deprecated, use importLibrary() instead.
     */ loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */ setScript() {
        var _a, _b;
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const params = {
            key: this.apiKey,
            channel: this.channel,
            client: this.client,
            libraries: this.libraries.length && this.libraries,
            v: this.version,
            mapIds: this.mapIds,
            language: this.language,
            region: this.region,
            authReferrerPolicy: this.authReferrerPolicy
        };
        // keep the URL minimal:
        Object.keys(params).forEach(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key)=>!params[key] && delete params[key]);
        if (!((_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary)) // tweaked copy of https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
        // which also sets the base url, the id, and the nonce
        /* eslint-disable */ ((g)=>{
            // @ts-ignore
            let h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window;
            // @ts-ignore
            b = b[c] || (b[c] = {});
            // @ts-ignore
            const d = b.maps || (b.maps = {}), r = new Set(), e = new URLSearchParams(), u = ()=>// @ts-ignore
                h || (h = new Promise((f, n)=>$57fb306f6b148ac8$var$__awaiter(this, void 0, void 0, function*() {
                        var _a;
                        yield a = m.createElement("script");
                        a.id = this.id;
                        e.set("libraries", [
                            ...r
                        ] + "");
                        // @ts-ignore
                        for(k in g)e.set(k.replace(/[A-Z]/g, (t)=>"_" + t[0].toLowerCase()), g[k]);
                        e.set("callback", c + ".maps." + q);
                        a.src = this.url + `?` + e;
                        d[q] = f;
                        a.onerror = ()=>h = n(Error(p + " could not load."));
                        // @ts-ignore
                        a.nonce = this.nonce || ((_a = m.querySelector("script[nonce]")) === null || _a === void 0 ? void 0 : _a.nonce) || "";
                        m.head.append(a);
                    })));
            // @ts-ignore
            d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n)=>r.add(f) && u().then(()=>d[l](f, ...n));
        })(params);
        // While most libraries populate the global namespace when loaded via bootstrap params,
        // this is not the case for "marker" when used with the inline bootstrap loader
        // (and maybe others in the future). So ensure there is an importLibrary for each:
        const libraryPromises = this.libraries.map((library)=>this.importLibrary(library));
        // ensure at least one library, to kick off loading...
        if (!libraryPromises.length) libraryPromises.push(this.importLibrary("core"));
        Promise.all(libraryPromises).then(()=>this.callback(), (error)=>{
            const event = new ErrorEvent("error", {
                error: error
            }); // for backwards compat
            this.loadErrorCallback(event);
        });
    }
    /**
     * Reset the loader state.
     */ reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) this.reset();
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.error(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(()=>{
                this.deleteScript();
                this.setScript();
            }, delay);
        } else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb)=>{
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) this.callback();
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader.This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setScript();
            }
        }
    }
}


var $3675200c0516c75b$exports = {};

$3675200c0516c75b$exports = (parcelRequire("hIarR")).getBundleURL("hyeyu") + "../pin.17ac4448.svg";


var $af8087a36eec0f8c$exports = {};

$af8087a36eec0f8c$exports = (parcelRequire("hIarR")).getBundleURL("hyeyu") + "../cluster-pin.5df8d604.svg";


var $80313a72c8cc9578$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$80313a72c8cc9578$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


const $c509ce46a93fe9c2$var$ARRAY_TYPES = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array
];
/** @typedef {Int8ArrayConstructor | Uint8ArrayConstructor | Uint8ClampedArrayConstructor | Int16ArrayConstructor | Uint16ArrayConstructor | Int32ArrayConstructor | Uint32ArrayConstructor | Float32ArrayConstructor | Float64ArrayConstructor} TypedArrayConstructor */ const $c509ce46a93fe9c2$var$VERSION = 1; // serialized format version
const $c509ce46a93fe9c2$var$HEADER_SIZE = 8;
class $c509ce46a93fe9c2$export$2e2bcd8739ae039 {
    /**
     * Creates an index from raw `ArrayBuffer` data.
     * @param {ArrayBuffer} data
     */ static from(data) {
        if (!(data instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
        const [magic, versionAndType] = new Uint8Array(data, 0, 2);
        if (magic !== 0xdb) throw new Error("Data does not appear to be in a KDBush format.");
        const version = versionAndType >> 4;
        if (version !== $c509ce46a93fe9c2$var$VERSION) throw new Error(`Got v${version} data when expected v${$c509ce46a93fe9c2$var$VERSION}.`);
        const ArrayType = $c509ce46a93fe9c2$var$ARRAY_TYPES[versionAndType & 0x0f];
        if (!ArrayType) throw new Error("Unrecognized array type.");
        const [nodeSize] = new Uint16Array(data, 2, 1);
        const [numItems] = new Uint32Array(data, 4, 1);
        return new $c509ce46a93fe9c2$export$2e2bcd8739ae039(numItems, nodeSize, ArrayType, data);
    }
    /**
     * Creates an index that will hold a given number of items.
     * @param {number} numItems
     * @param {number} [nodeSize=64] Size of the KD-tree node (64 by default).
     * @param {TypedArrayConstructor} [ArrayType=Float64Array] The array type used for coordinates storage (`Float64Array` by default).
     * @param {ArrayBuffer} [data] (For internal use only)
     */ constructor(numItems, nodeSize = 64, ArrayType = Float64Array, data){
        if (isNaN(numItems) || numItems < 0) throw new Error(`Unpexpected numItems value: ${numItems}.`);
        this.numItems = +numItems;
        this.nodeSize = Math.min(Math.max(+nodeSize, 2), 65535);
        this.ArrayType = ArrayType;
        this.IndexArrayType = numItems < 65536 ? Uint16Array : Uint32Array;
        const arrayTypeIndex = $c509ce46a93fe9c2$var$ARRAY_TYPES.indexOf(this.ArrayType);
        const coordsByteSize = numItems * 2 * this.ArrayType.BYTES_PER_ELEMENT;
        const idsByteSize = numItems * this.IndexArrayType.BYTES_PER_ELEMENT;
        const padCoords = (8 - idsByteSize % 8) % 8;
        if (arrayTypeIndex < 0) throw new Error(`Unexpected typed array class: ${ArrayType}.`);
        if (data && data instanceof ArrayBuffer) {
            this.data = data;
            this.ids = new this.IndexArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = numItems * 2;
            this._finished = true;
        } else {
            this.data = new ArrayBuffer($c509ce46a93fe9c2$var$HEADER_SIZE + coordsByteSize + idsByteSize + padCoords);
            this.ids = new this.IndexArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE, numItems);
            this.coords = new this.ArrayType(this.data, $c509ce46a93fe9c2$var$HEADER_SIZE + idsByteSize + padCoords, numItems * 2);
            this._pos = 0;
            this._finished = false;
            // set header
            new Uint8Array(this.data, 0, 2).set([
                0xdb,
                ($c509ce46a93fe9c2$var$VERSION << 4) + arrayTypeIndex
            ]);
            new Uint16Array(this.data, 2, 1)[0] = nodeSize;
            new Uint32Array(this.data, 4, 1)[0] = numItems;
        }
    }
    /**
     * Add a point to the index.
     * @param {number} x
     * @param {number} y
     * @returns {number} An incremental index associated with the added item (starting from `0`).
     */ add(x, y) {
        const index = this._pos >> 1;
        this.ids[index] = index;
        this.coords[this._pos++] = x;
        this.coords[this._pos++] = y;
        return index;
    }
    /**
     * Perform indexing of the added points.
     */ finish() {
        const numAdded = this._pos >> 1;
        if (numAdded !== this.numItems) throw new Error(`Added ${numAdded} items when expected ${this.numItems}.`);
        // kd-sort both arrays for efficient search
        $c509ce46a93fe9c2$var$sort(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0);
        this._finished = true;
        return this;
    }
    /**
     * Search the index for items within a given bounding box.
     * @param {number} minX
     * @param {number} minY
     * @param {number} maxX
     * @param {number} maxY
     * @returns {number[]} An array of indices correponding to the found items.
     */ range(minX, minY, maxX, maxY) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        // recursively search for items in range in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++){
                    const x = coords[2 * i];
                    const y = coords[2 * i + 1];
                    if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
                }
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? minX <= x : minY <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? maxX >= x : maxY >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
    /**
     * Search the index for items within a given radius.
     * @param {number} qx
     * @param {number} qy
     * @param {number} r Query radius.
     * @returns {number[]} An array of indices correponding to the found items.
     */ within(qx, qy, r) {
        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
        const { ids: ids, coords: coords, nodeSize: nodeSize } = this;
        const stack = [
            0,
            ids.length - 1,
            0
        ];
        const result = [];
        const r2 = r * r;
        // recursively search for items within radius in the kd-sorted arrays
        while(stack.length){
            const axis = stack.pop() || 0;
            const right = stack.pop() || 0;
            const left = stack.pop() || 0;
            // if we reached "tree node", search linearly
            if (right - left <= nodeSize) {
                for(let i = left; i <= right; i++)if ($c509ce46a93fe9c2$var$sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
                continue;
            }
            // otherwise find the middle index
            const m = left + right >> 1;
            // include the middle item if it's in range
            const x = coords[2 * m];
            const y = coords[2 * m + 1];
            if ($c509ce46a93fe9c2$var$sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
            // queue search in halves that intersect the query
            if (axis === 0 ? qx - r <= x : qy - r <= y) {
                stack.push(left);
                stack.push(m - 1);
                stack.push(1 - axis);
            }
            if (axis === 0 ? qx + r >= x : qy + r >= y) {
                stack.push(m + 1);
                stack.push(right);
                stack.push(1 - axis);
            }
        }
        return result;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} nodeSize
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, left, right, axis) {
    if (right - left <= nodeSize) return;
    const m = left + right >> 1; // middle index
    // sort ids and coords around the middle index so that the halves lie
    // either left/right or top/bottom correspondingly (taking turns)
    $c509ce46a93fe9c2$var$select(ids, coords, m, left, right, axis);
    // recursively kd-sort first half and second half on the opposite axis
    $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, left, m - 1, 1 - axis);
    $c509ce46a93fe9c2$var$sort(ids, coords, nodeSize, m + 1, right, 1 - axis);
}
/**
 * Custom Floyd-Rivest selection algorithm: sort ids and coords so that
 * [left..k-1] items are smaller than k-th item (on either x or y axis)
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} k
 * @param {number} left
 * @param {number} right
 * @param {number} axis
 */ function $c509ce46a93fe9c2$var$select(ids, coords, k, left, right, axis) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $c509ce46a93fe9c2$var$select(ids, coords, k, newLeft, newRight, axis);
        }
        const t = coords[2 * k + axis];
        let i = left;
        let j = right;
        $c509ce46a93fe9c2$var$swapItem(ids, coords, left, k);
        if (coords[2 * right + axis] > t) $c509ce46a93fe9c2$var$swapItem(ids, coords, left, right);
        while(i < j){
            $c509ce46a93fe9c2$var$swapItem(ids, coords, i, j);
            i++;
            j--;
            while(coords[2 * i + axis] < t)i++;
            while(coords[2 * j + axis] > t)j--;
        }
        if (coords[2 * left + axis] === t) $c509ce46a93fe9c2$var$swapItem(ids, coords, left, j);
        else {
            j++;
            $c509ce46a93fe9c2$var$swapItem(ids, coords, j, right);
        }
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}
/**
 * @param {Uint16Array | Uint32Array} ids
 * @param {InstanceType<TypedArrayConstructor>} coords
 * @param {number} i
 * @param {number} j
 */ function $c509ce46a93fe9c2$var$swapItem(ids, coords, i, j) {
    $c509ce46a93fe9c2$var$swap(ids, i, j);
    $c509ce46a93fe9c2$var$swap(coords, 2 * i, 2 * j);
    $c509ce46a93fe9c2$var$swap(coords, 2 * i + 1, 2 * j + 1);
}
/**
 * @param {InstanceType<TypedArrayConstructor>} arr
 * @param {number} i
 * @param {number} j
 */ function $c509ce46a93fe9c2$var$swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}
/**
 * @param {number} ax
 * @param {number} ay
 * @param {number} bx
 * @param {number} by
 */ function $c509ce46a93fe9c2$var$sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}


const $a4cd6cdb96430eae$var$defaultOptions = {
    minZoom: 0,
    maxZoom: 16,
    minPoints: 2,
    radius: 40,
    extent: 512,
    nodeSize: 64,
    log: false,
    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,
    // a reduce function for calculating custom cluster properties
    reduce: null,
    // properties to use for individual points when running the reducer
    map: (props)=>props // props => ({sum: props.my_value})
};
const $a4cd6cdb96430eae$var$fround = Math.fround || ((tmp)=>(x)=>{
        tmp[0] = +x;
        return tmp[0];
    })(new Float32Array(1));
const $a4cd6cdb96430eae$var$OFFSET_ZOOM = 2;
const $a4cd6cdb96430eae$var$OFFSET_ID = 3;
const $a4cd6cdb96430eae$var$OFFSET_PARENT = 4;
const $a4cd6cdb96430eae$var$OFFSET_NUM = 5;
const $a4cd6cdb96430eae$var$OFFSET_PROP = 6;
class $a4cd6cdb96430eae$export$2e2bcd8739ae039 {
    constructor(options){
        this.options = Object.assign(Object.create($a4cd6cdb96430eae$var$defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
        this.stride = this.options.reduce ? 7 : 6;
        this.clusterProps = [];
    }
    load(points) {
        const { log: log, minZoom: minZoom, maxZoom: maxZoom } = this.options;
        if (log) console.time("total time");
        const timerId = `prepare ${points.length} points`;
        if (log) console.time(timerId);
        this.points = points;
        // generate a cluster object for each point and index input points into a KD-tree
        const data = [];
        for(let i = 0; i < points.length; i++){
            const p = points[i];
            if (!p.geometry) continue;
            const [lng, lat] = p.geometry.coordinates;
            const x = $a4cd6cdb96430eae$var$fround($a4cd6cdb96430eae$var$lngX(lng));
            const y = $a4cd6cdb96430eae$var$fround($a4cd6cdb96430eae$var$latY(lat));
            // store internal point/cluster data in flat numeric arrays for performance
            data.push(x, y, Infinity, i, -1, 1 // number of points in a cluster
            );
            if (this.options.reduce) data.push(0); // noop
        }
        let tree = this.trees[maxZoom + 1] = this._createTree(data);
        if (log) console.timeEnd(timerId);
        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for(let z = maxZoom; z >= minZoom; z--){
            const now = +Date.now();
            // create a new set of clusters for the zoom and index them with a KD-tree
            tree = this.trees[z] = this._createTree(this._cluster(tree, z));
            if (log) console.log("z%d: %d clusters in %dms", z, tree.numItems, +Date.now() - now);
        }
        if (log) console.timeEnd("total time");
        return this;
    }
    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));
        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([
                minLng,
                minLat,
                180,
                maxLat
            ], zoom);
            const westernHem = this.getClusters([
                -180,
                minLat,
                maxLng,
                maxLat
            ], zoom);
            return easternHem.concat(westernHem);
        }
        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range($a4cd6cdb96430eae$var$lngX(minLng), $a4cd6cdb96430eae$var$latY(maxLat), $a4cd6cdb96430eae$var$lngX(maxLng), $a4cd6cdb96430eae$var$latY(minLat));
        const data = tree.data;
        const clusters = [];
        for (const id of ids){
            const k = this.stride * id;
            clusters.push(data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1 ? $a4cd6cdb96430eae$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]]);
        }
        return clusters;
    }
    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = "No cluster with the specified id.";
        const tree = this.trees[originZoom];
        if (!tree) throw new Error(errorMsg);
        const data = tree.data;
        if (originId * this.stride >= data.length) throw new Error(errorMsg);
        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const x = data[originId * this.stride];
        const y = data[originId * this.stride + 1];
        const ids = tree.within(x, y, r);
        const children = [];
        for (const id of ids){
            const k = id * this.stride;
            if (data[k + $a4cd6cdb96430eae$var$OFFSET_PARENT] === clusterId) children.push(data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1 ? $a4cd6cdb96430eae$var$getClusterJSON(data, k, this.clusterProps) : this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]]);
        }
        if (children.length === 0) throw new Error(errorMsg);
        return children;
    }
    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;
        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);
        return leaves;
    }
    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const { extent: extent, radius: radius } = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;
        const tile = {
            features: []
        };
        this._addTileFeatures(tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom), tree.data, x, y, z2, tile);
        if (x === 0) this._addTileFeatures(tree.range(1 - p / z2, top, 1, bottom), tree.data, z2, y, z2, tile);
        if (x === z2 - 1) this._addTileFeatures(tree.range(0, top, p / z2, bottom), tree.data, -1, y, z2, tile);
        return tile.features.length ? tile : null;
    }
    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while(expansionZoom <= this.options.maxZoom){
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }
    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);
        for (const child of children){
            const props = child.properties;
            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) // skip the whole cluster
                skipped += props.point_count;
                else // enter the cluster
                skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
            } else if (skipped < offset) // skip a single point
            skipped++;
            else // add a single point
            result.push(child);
            if (result.length === limit) break;
        }
        return skipped;
    }
    _createTree(data) {
        const tree = new (0, $c509ce46a93fe9c2$export$2e2bcd8739ae039)(data.length / this.stride | 0, this.options.nodeSize, Float32Array);
        for(let i = 0; i < data.length; i += this.stride)tree.add(data[i], data[i + 1]);
        tree.finish();
        tree.data = data;
        return tree;
    }
    _addTileFeatures(ids, data, x, y, z2, tile) {
        for (const i of ids){
            const k = i * this.stride;
            const isCluster = data[k + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1;
            let tags, px, py;
            if (isCluster) {
                tags = $a4cd6cdb96430eae$var$getClusterProperties(data, k, this.clusterProps);
                px = data[k];
                py = data[k + 1];
            } else {
                const p = this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]];
                tags = p.properties;
                const [lng, lat] = p.geometry.coordinates;
                px = $a4cd6cdb96430eae$var$lngX(lng);
                py = $a4cd6cdb96430eae$var$latY(lat);
            }
            const f = {
                type: 1,
                geometry: [
                    [
                        Math.round(this.options.extent * (px * z2 - x)),
                        Math.round(this.options.extent * (py * z2 - y))
                    ]
                ],
                tags: tags
            };
            // assign id
            let id;
            if (isCluster || this.options.generateId) // optionally generate id for points
            id = data[k + $a4cd6cdb96430eae$var$OFFSET_ID];
            else // keep id if already assigned
            id = this.points[data[k + $a4cd6cdb96430eae$var$OFFSET_ID]].id;
            if (id !== undefined) f.id = id;
            tile.features.push(f);
        }
    }
    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }
    _cluster(tree, zoom) {
        const { radius: radius, extent: extent, reduce: reduce, minPoints: minPoints } = this.options;
        const r = radius / (extent * Math.pow(2, zoom));
        const data = tree.data;
        const nextData = [];
        const stride = this.stride;
        // loop through each point
        for(let i = 0; i < data.length; i += stride){
            // if we've already visited the point at this zoom level, skip it
            if (data[i + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
            data[i + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom;
            // find all nearby points
            const x = data[i];
            const y = data[i + 1];
            const neighborIds = tree.within(data[i], data[i + 1], r);
            const numPointsOrigin = data[i + $a4cd6cdb96430eae$var$OFFSET_NUM];
            let numPoints = numPointsOrigin;
            // count the number of points in a potential cluster
            for (const neighborId of neighborIds){
                const k = neighborId * stride;
                // filter out neighbors that are already processed
                if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] > zoom) numPoints += data[k + $a4cd6cdb96430eae$var$OFFSET_NUM];
            }
            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = x * numPointsOrigin;
                let wy = y * numPointsOrigin;
                let clusterProperties;
                let clusterPropIndex = -1;
                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = ((i / stride | 0) << 5) + (zoom + 1) + this.points.length;
                for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom; // save the zoom (so it doesn't get processed twice)
                    const numPoints2 = data[k + $a4cd6cdb96430eae$var$OFFSET_NUM];
                    wx += data[k] * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += data[k + 1] * numPoints2;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_PARENT] = id;
                    if (reduce) {
                        if (!clusterProperties) {
                            clusterProperties = this._map(data, i, true);
                            clusterPropIndex = this.clusterProps.length;
                            this.clusterProps.push(clusterProperties);
                        }
                        reduce(clusterProperties, this._map(data, k));
                    }
                }
                data[i + $a4cd6cdb96430eae$var$OFFSET_PARENT] = id;
                nextData.push(wx / numPoints, wy / numPoints, Infinity, id, -1, numPoints);
                if (reduce) nextData.push(clusterPropIndex);
            } else {
                for(let j = 0; j < stride; j++)nextData.push(data[i + j]);
                if (numPoints > 1) for (const neighborId of neighborIds){
                    const k = neighborId * stride;
                    if (data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] <= zoom) continue;
                    data[k + $a4cd6cdb96430eae$var$OFFSET_ZOOM] = zoom;
                    for(let j = 0; j < stride; j++)nextData.push(data[k + j]);
                }
            }
        }
        return nextData;
    }
    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return clusterId - this.points.length >> 5;
    }
    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }
    _map(data, i, clone) {
        if (data[i + $a4cd6cdb96430eae$var$OFFSET_NUM] > 1) {
            const props = this.clusterProps[data[i + $a4cd6cdb96430eae$var$OFFSET_PROP]];
            return clone ? Object.assign({}, props) : props;
        }
        const original = this.points[data[i + $a4cd6cdb96430eae$var$OFFSET_ID]].properties;
        const result = this.options.map(original);
        return clone && result === original ? Object.assign({}, result) : result;
    }
}
function $a4cd6cdb96430eae$var$getClusterJSON(data, i, clusterProps) {
    return {
        type: "Feature",
        id: data[i + $a4cd6cdb96430eae$var$OFFSET_ID],
        properties: $a4cd6cdb96430eae$var$getClusterProperties(data, i, clusterProps),
        geometry: {
            type: "Point",
            coordinates: [
                $a4cd6cdb96430eae$var$xLng(data[i]),
                $a4cd6cdb96430eae$var$yLat(data[i + 1])
            ]
        }
    };
}
function $a4cd6cdb96430eae$var$getClusterProperties(data, i, clusterProps) {
    const count = data[i + $a4cd6cdb96430eae$var$OFFSET_NUM];
    const abbrev = count >= 10000 ? `${Math.round(count / 1000)}k` : count >= 1000 ? `${Math.round(count / 100) / 10}k` : count;
    const propIndex = data[i + $a4cd6cdb96430eae$var$OFFSET_PROP];
    const properties = propIndex === -1 ? {} : Object.assign({}, clusterProps[propIndex]);
    return Object.assign(properties, {
        cluster: true,
        cluster_id: data[i + $a4cd6cdb96430eae$var$OFFSET_ID],
        point_count: count,
        point_count_abbreviated: abbrev
    });
}
// longitude/latitude to spherical mercator in [0..1] range
function $a4cd6cdb96430eae$var$lngX(lng) {
    return lng / 360 + 0.5;
}
function $a4cd6cdb96430eae$var$latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = 0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI;
    return y < 0 ? 0 : y > 1 ? 1 : y;
}
// spherical mercator to longitude/latitude
function $a4cd6cdb96430eae$var$xLng(x) {
    return (x - 0.5) * 360;
}
function $a4cd6cdb96430eae$var$yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $b91f9f2fdb98b359$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
/**
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * util class that creates a common set of convenience functions to wrap
 * shared behavior of Advanced Markers and Markers.
 */ class $b91f9f2fdb98b359$export$87c23728007fa1bd {
    static isAdvancedMarkerAvailable(map) {
        return google.maps.marker && map.getMapCapabilities().isAdvancedMarkersAvailable === true;
    }
    static isAdvancedMarker(marker) {
        return google.maps.marker && marker instanceof google.maps.marker.AdvancedMarkerElement;
    }
    static setMap(marker, map) {
        if (this.isAdvancedMarker(marker)) marker.map = map;
        else marker.setMap(map);
    }
    static getPosition(marker) {
        // SuperClusterAlgorithm.calculate expects a LatLng instance so we fake it for Adv Markers
        if (this.isAdvancedMarker(marker)) {
            if (marker.position) {
                if (marker.position instanceof google.maps.LatLng) return marker.position;
                // since we can't cast to LatLngLiteral for reasons =(
                if (marker.position.lat && marker.position.lng) return new google.maps.LatLng(marker.position.lat, marker.position.lng);
            }
            return new google.maps.LatLng(null);
        }
        return marker.getPosition();
    }
    static getVisible(marker) {
        if (this.isAdvancedMarker(marker)) /**
             * Always return true for Advanced Markers because the clusterer
             * uses getVisible as a way to count legacy markers not as an actual
             * indicator of visibility for some reason. Even when markers are hidden
             * Marker.getVisible returns `true` and this is used to set the marker count
             * on the cluster. See the behavior of Cluster.count
             */ return true;
        return marker.getVisible();
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b91f9f2fdb98b359$export$57ed47926628b770 {
    constructor({ markers: markers, position: position }){
        this.markers = markers;
        if (position) {
            if (position instanceof google.maps.LatLng) this._position = position;
            else this._position = new google.maps.LatLng(position);
        }
    }
    get bounds() {
        if (this.markers.length === 0 && !this._position) return;
        const bounds = new google.maps.LatLngBounds(this._position, this._position);
        for (const marker of this.markers)bounds.extend($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker));
        return bounds;
    }
    get position() {
        return this._position || this.bounds.getCenter();
    }
    /**
     * Get the count of **visible** markers.
     */ get count() {
        return this.markers.filter((m)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.getVisible(m)).length;
    }
    /**
     * Add a marker to the cluster.
     */ push(marker) {
        this.markers.push(marker);
    }
    /**
     * Cleanup references and remove marker from map.
     */ delete() {
        if (this.marker) {
            $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(this.marker, null);
            this.marker = undefined;
        }
        this.markers.length = 0;
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the markers visible in a padded map viewport
 *
 * @param map
 * @param mapCanvasProjection
 * @param markers The list of marker to filter
 * @param viewportPaddingPixels The padding in pixel
 * @returns The list of markers in the padded viewport
 */ const $b91f9f2fdb98b359$export$6dcea57a2b662207 = (map, mapCanvasProjection, markers, viewportPaddingPixels)=>{
    const extendedMapBounds = $b91f9f2fdb98b359$export$57247bea612a5e84(map.getBounds(), mapCanvasProjection, viewportPaddingPixels);
    return markers.filter((marker)=>extendedMapBounds.contains($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)));
};
/**
 * Extends a bounds by a number of pixels in each direction
 */ const $b91f9f2fdb98b359$export$57247bea612a5e84 = (bounds, projection, numPixels)=>{
    const { northEast: northEast, southWest: southWest } = $b91f9f2fdb98b359$var$latLngBoundsToPixelBounds(bounds, projection);
    const extendedPixelBounds = $b91f9f2fdb98b359$export$8cd793acb3b8e8e8({
        northEast: northEast,
        southWest: southWest
    }, numPixels);
    return $b91f9f2fdb98b359$export$21d7a872d22a0f92(extendedPixelBounds, projection);
};
/**
 * Gets the extended bounds as a bbox [westLng, southLat, eastLng, northLat]
 */ const $b91f9f2fdb98b359$export$6341d7e267bda241 = (bounds, projection, pixels)=>{
    const extended = $b91f9f2fdb98b359$export$57247bea612a5e84(bounds, projection, pixels);
    const ne = extended.getNorthEast();
    const sw = extended.getSouthWest();
    return [
        sw.lng(),
        sw.lat(),
        ne.lng(),
        ne.lat()
    ];
};
/**
 * Returns the distance between 2 positions.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$export$b59117efbc9c7af = (p1, p2)=>{
    const R = 6371; // Radius of the Earth in km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLon = (p2.lng - p1.lng) * Math.PI / 180;
    const sinDLat = Math.sin(dLat / 2);
    const sinDLon = Math.sin(dLon / 2);
    const a = sinDLat * sinDLat + Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) * sinDLon * sinDLon;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
};
/**
 * Converts a LatLng bound to pixels.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$var$latLngBoundsToPixelBounds = (bounds, projection)=>{
    return {
        northEast: projection.fromLatLngToDivPixel(bounds.getNorthEast()),
        southWest: projection.fromLatLngToDivPixel(bounds.getSouthWest())
    };
};
/**
 * Extends a pixel bounds by numPixels in all directions.
 *
 * @hidden
 */ const $b91f9f2fdb98b359$export$8cd793acb3b8e8e8 = ({ northEast: northEast, southWest: southWest }, numPixels)=>{
    northEast.x += numPixels;
    northEast.y -= numPixels;
    southWest.x -= numPixels;
    southWest.y += numPixels;
    return {
        northEast: northEast,
        southWest: southWest
    };
};
/**
 * @hidden
 */ const $b91f9f2fdb98b359$export$21d7a872d22a0f92 = ({ northEast: northEast, southWest: southWest }, projection)=>{
    const sw = projection.fromDivPixelToLatLng(southWest);
    const ne = projection.fromDivPixelToLatLng(northEast);
    return new google.maps.LatLngBounds(sw, ne);
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @hidden
 */ class $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor({ maxZoom: maxZoom = 16 }){
        this.maxZoom = maxZoom;
    }
    /**
     * Helper function to bypass clustering based upon some map state such as
     * zoom, number of markers, etc.
     *
     * ```typescript
     *  cluster({markers, map}: AlgorithmInput): Cluster[] {
     *    if (shouldBypassClustering(map)) {
     *      return this.noop({markers})
     *    }
     * }
     * ```
     */ noop({ markers: markers }) {
        return $b91f9f2fdb98b359$export$8793edee2d425525(markers);
    }
}
/**
 * Abstract viewport algorithm proves a class to filter markers by a padded
 * viewport. This is a common optimization.
 *
 * @hidden
 */ class $b91f9f2fdb98b359$export$d8a438b9a55dba76 extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var { viewportPadding: viewportPadding = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "viewportPadding"
        ]);
        super(options);
        this.viewportPadding = 60;
        this.viewportPadding = viewportPadding;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: false
        };
        return {
            clusters: this.cluster({
                markers: $b91f9f2fdb98b359$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
}
/**
 * @hidden
 */ const $b91f9f2fdb98b359$export$8793edee2d425525 = (markers)=>{
    const clusters = markers.map((marker)=>new $b91f9f2fdb98b359$export$57ed47926628b770({
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker),
            markers: [
                marker
            ]
        }));
    return clusters;
};
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default Grid algorithm historically used in Google Maps marker
 * clustering.
 *
 * The Grid algorithm does not implement caching and markers may flash as the
 * viewport changes. Instead use {@link SuperClusterAlgorithm}.
 */ class $b91f9f2fdb98b359$export$dfa3b6d6f10e5cac extends $b91f9f2fdb98b359$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxDistance: maxDistance = 40000, gridSize: gridSize = 40 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxDistance",
            "gridSize"
        ]);
        super(options);
        this.clusters = [];
        this.state = {
            zoom: -1
        };
        this.maxDistance = maxDistance;
        this.gridSize = gridSize;
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        const state = {
            zoom: map.getZoom()
        };
        let changed = false;
        if (this.state.zoom >= this.maxZoom && state.zoom >= this.maxZoom) ;
        else changed = !(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(this.state, state);
        this.state = state;
        if (map.getZoom() >= this.maxZoom) return {
            clusters: this.noop({
                markers: markers
            }),
            changed: changed
        };
        return {
            clusters: this.cluster({
                markers: $b91f9f2fdb98b359$export$6dcea57a2b662207(map, mapCanvasProjection, markers, this.viewportPadding),
                map: map,
                mapCanvasProjection: mapCanvasProjection
            })
        };
    }
    cluster({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        this.clusters = [];
        markers.forEach((marker)=>{
            this.addToClosestCluster(marker, map, mapCanvasProjection);
        });
        return this.clusters;
    }
    addToClosestCluster(marker, map, projection) {
        let maxDistance = this.maxDistance; // Some large number
        let cluster = null;
        for(let i = 0; i < this.clusters.length; i++){
            const candidate = this.clusters[i];
            const distance = $b91f9f2fdb98b359$export$b59117efbc9c7af(candidate.bounds.getCenter().toJSON(), $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker).toJSON());
            if (distance < maxDistance) {
                maxDistance = distance;
                cluster = candidate;
            }
        }
        if (cluster && $b91f9f2fdb98b359$export$57247bea612a5e84(cluster.bounds, projection, this.gridSize).contains($b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker))) cluster.push(marker);
        else {
            const cluster = new $b91f9f2fdb98b359$export$57ed47926628b770({
                markers: [
                    marker
                ]
            });
            this.clusters.push(cluster);
        }
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Noop algorithm does not generate any clusters or filter markers by the an extended viewport.
 */ class $b91f9f2fdb98b359$export$f6cacfea2ccd84d3 extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var options = $b91f9f2fdb98b359$var$__rest(_a, []);
        super(options);
    }
    calculate({ markers: markers, map: map, mapCanvasProjection: mapCanvasProjection }) {
        return {
            clusters: this.cluster({
                markers: markers,
                map: map,
                mapCanvasProjection: mapCanvasProjection
            }),
            changed: false
        };
    }
    cluster(input) {
        return this.noop(input);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $b91f9f2fdb98b359$export$3c4c9430ac0fb1eb extends $b91f9f2fdb98b359$export$1e1bee200f7e743e {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxZoom",
            "radius"
        ]);
        super({
            maxZoom: maxZoom
        });
        this.state = {
            zoom: -1
        };
        this.superCluster = new (0, $a4cd6cdb96430eae$export$2e2bcd8739ae039)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
    }
    calculate(input) {
        let changed = false;
        const state = {
            zoom: input.map.getZoom()
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (!changed) {
            if (this.state.zoom <= this.maxZoom || state.zoom <= this.maxZoom) changed = !(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(this.state, state);
        }
        this.state = state;
        if (changed) this.clusters = this.cluster(input);
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map }) {
        return this.superCluster.getClusters([
            -180,
            -90,
            180,
            90
        ], Math.round(map.getZoom())).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A very fast JavaScript algorithm for geospatial point clustering using KD trees.
 *
 * @see https://www.npmjs.com/package/supercluster for more information on options.
 */ class $b91f9f2fdb98b359$export$80a71135475bbaa7 extends $b91f9f2fdb98b359$export$d8a438b9a55dba76 {
    constructor(_a){
        var { maxZoom: maxZoom, radius: radius = 60, viewportPadding: viewportPadding = 60 } = _a, options = $b91f9f2fdb98b359$var$__rest(_a, [
            "maxZoom",
            "radius",
            "viewportPadding"
        ]);
        super({
            maxZoom: maxZoom,
            viewportPadding: viewportPadding
        });
        this.superCluster = new (0, $a4cd6cdb96430eae$export$2e2bcd8739ae039)(Object.assign({
            maxZoom: this.maxZoom,
            radius: radius
        }, options));
        this.state = {
            zoom: -1,
            view: [
                0,
                0,
                0,
                0
            ]
        };
    }
    calculate(input) {
        const state = {
            zoom: Math.round(input.map.getZoom()),
            view: $b91f9f2fdb98b359$export$6341d7e267bda241(input.map.getBounds(), input.mapCanvasProjection, this.viewportPadding)
        };
        let changed = !(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(this.state, state);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($80313a72c8cc9578$exports)))(input.markers, this.markers)) {
            changed = true;
            // TODO use proxy to avoid copy?
            this.markers = [
                ...input.markers
            ];
            const points = this.markers.map((marker)=>{
                const position = $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker);
                const coordinates = [
                    position.lng(),
                    position.lat()
                ];
                return {
                    type: "Feature",
                    geometry: {
                        type: "Point",
                        coordinates: coordinates
                    },
                    properties: {
                        marker: marker
                    }
                };
            });
            this.superCluster.load(points);
        }
        if (changed) {
            this.clusters = this.cluster(input);
            this.state = state;
        }
        return {
            clusters: this.clusters,
            changed: changed
        };
    }
    cluster({ map: map, mapCanvasProjection: mapCanvasProjection }) {
        /* recalculate new state because we can't use the cached version. */ const state = {
            zoom: Math.round(map.getZoom()),
            view: $b91f9f2fdb98b359$export$6341d7e267bda241(map.getBounds(), mapCanvasProjection, this.viewportPadding)
        };
        return this.superCluster.getClusters(state.view, state.zoom).map((feature)=>this.transformCluster(feature));
    }
    transformCluster({ geometry: { coordinates: [lng, lat] }, properties: properties }) {
        if (properties.cluster) return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: this.superCluster.getLeaves(properties.cluster_id, Infinity).map((leaf)=>leaf.properties.marker),
            position: {
                lat: lat,
                lng: lng
            }
        });
        const marker = properties.marker;
        return new $b91f9f2fdb98b359$export$57ed47926628b770({
            markers: [
                marker
            ],
            position: $b91f9f2fdb98b359$export$87c23728007fa1bd.getPosition(marker)
        });
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides statistics on all clusters in the current render cycle for use in {@link Renderer.render}.
 */ class $b91f9f2fdb98b359$export$2deda6e6beba3286 {
    constructor(markers, clusters){
        this.markers = {
            sum: markers.length
        };
        const clusterMarkerCounts = clusters.map((a)=>a.count);
        const clusterMarkerSum = clusterMarkerCounts.reduce((a, b)=>a + b, 0);
        this.clusters = {
            count: clusters.length,
            markers: {
                mean: clusterMarkerSum / clusters.length,
                sum: clusterMarkerSum,
                min: Math.min(...clusterMarkerCounts),
                max: Math.max(...clusterMarkerCounts)
            }
        };
    }
}
class $b91f9f2fdb98b359$export$7db59afbbd5bcace {
    /**
     * The default render function for the library used by {@link MarkerClusterer}.
     *
     * Currently set to use the following:
     *
     * ```typescript
     * // change color if this cluster has more markers than the mean cluster
     * const color =
     *   count > Math.max(10, stats.clusters.markers.mean)
     *     ? "#ff0000"
     *     : "#0000ff";
     *
     * // create svg url with fill color
     * const svg = window.btoa(`
     * <svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
     *   <circle cx="120" cy="120" opacity=".6" r="70" />
     *   <circle cx="120" cy="120" opacity=".3" r="90" />
     *   <circle cx="120" cy="120" opacity=".2" r="110" />
     *   <circle cx="120" cy="120" opacity=".1" r="130" />
     * </svg>`);
     *
     * // create marker using svg icon
     * return new google.maps.Marker({
     *   position,
     *   icon: {
     *     url: `data:image/svg+xml;base64,${svg}`,
     *     scaledSize: new google.maps.Size(45, 45),
     *   },
     *   label: {
     *     text: String(count),
     *     color: "rgba(255,255,255,0.9)",
     *     fontSize: "12px",
     *   },
     *   // adjust zIndex to be above other markers
     *   zIndex: 1000 + count,
     * });
     * ```
     */ render({ count: count, position: position }, stats, map) {
        // change color if this cluster has more markers than the mean cluster
        const color = count > Math.max(10, stats.clusters.markers.mean) ? "#ff0000" : "#0000ff";
        // create svg literal with fill color
        const svg = `<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="50" height="50">
<circle cx="120" cy="120" opacity=".6" r="70" />
<circle cx="120" cy="120" opacity=".3" r="90" />
<circle cx="120" cy="120" opacity=".2" r="110" />
<text x="50%" y="50%" style="fill:#fff" text-anchor="middle" font-size="50" dominant-baseline="middle" font-family="roboto,arial,sans-serif">${count}</text>
</svg>`;
        const title = `Cluster of ${count} markers`, // adjust zIndex to be above other markers
        zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;
        if ($b91f9f2fdb98b359$export$87c23728007fa1bd.isAdvancedMarkerAvailable(map)) {
            // create cluster SVG element
            const parser = new DOMParser();
            const svgEl = parser.parseFromString(svg, "image/svg+xml").documentElement;
            svgEl.setAttribute("transform", "translate(0 25)");
            const clusterOptions = {
                map: map,
                position: position,
                zIndex: zIndex,
                title: title,
                content: svgEl
            };
            return new google.maps.marker.AdvancedMarkerElement(clusterOptions);
        }
        const clusterOptions = {
            position: position,
            zIndex: zIndex,
            title: title,
            icon: {
                url: `data:image/svg+xml;base64,${btoa(svg)}`,
                anchor: new google.maps.Point(25, 25)
            }
        };
        return new google.maps.Marker(clusterOptions);
    }
}
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Extends an object's prototype by another's.
 *
 * @param type1 The Type to be extended.
 * @param type2 The Type to extend with.
 * @ignore
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b91f9f2fdb98b359$var$extend(type1, type2) {
    /* istanbul ignore next */ // eslint-disable-next-line prefer-const
    for(let property in type2.prototype)type1.prototype[property] = type2.prototype[property];
}
/**
 * @ignore
 */ class $b91f9f2fdb98b359$var$OverlayViewSafe {
    constructor(){
        // MarkerClusterer implements google.maps.OverlayView interface. We use the
        // extend function to extend MarkerClusterer with google.maps.OverlayView
        // because it might not always be available when the code is defined so we
        // look for it at the last possible moment. If it doesn't exist now then
        // there is no point going ahead :)
        $b91f9f2fdb98b359$var$extend($b91f9f2fdb98b359$var$OverlayViewSafe, google.maps.OverlayView);
    }
}
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b91f9f2fdb98b359$export$f87b0506a2cf0bc;
(function(MarkerClustererEvents) {
    MarkerClustererEvents["CLUSTERING_BEGIN"] = "clusteringbegin";
    MarkerClustererEvents["CLUSTERING_END"] = "clusteringend";
    MarkerClustererEvents["CLUSTER_CLICK"] = "click";
})($b91f9f2fdb98b359$export$f87b0506a2cf0bc || ($b91f9f2fdb98b359$export$f87b0506a2cf0bc = {}));
const $b91f9f2fdb98b359$export$b434dc9855552644 = (_, cluster, map)=>{
    map.fitBounds(cluster.bounds);
};
/**
 * MarkerClusterer creates and manages per-zoom-level clusters for large amounts
 * of markers. See {@link MarkerClustererOptions} for more details.
 *
 */ class $b91f9f2fdb98b359$export$58bd9bb9fcf3dd4f extends $b91f9f2fdb98b359$var$OverlayViewSafe {
    constructor({ map: map, markers: markers = [], algorithmOptions: algorithmOptions = {}, algorithm: algorithm = new $b91f9f2fdb98b359$export$3c4c9430ac0fb1eb(algorithmOptions), renderer: renderer = new $b91f9f2fdb98b359$export$7db59afbbd5bcace(), onClusterClick: onClusterClick = $b91f9f2fdb98b359$export$b434dc9855552644 }){
        super();
        this.markers = [
            ...markers
        ];
        this.clusters = [];
        this.algorithm = algorithm;
        this.renderer = renderer;
        this.onClusterClick = onClusterClick;
        if (map) this.setMap(map);
    }
    addMarker(marker, noDraw) {
        if (this.markers.includes(marker)) return;
        this.markers.push(marker);
        if (!noDraw) this.render();
    }
    addMarkers(markers, noDraw) {
        markers.forEach((marker)=>{
            this.addMarker(marker, true);
        });
        if (!noDraw) this.render();
    }
    removeMarker(marker, noDraw) {
        const index = this.markers.indexOf(marker);
        if (index === -1) // Marker is not in our list of markers, so do nothing:
        return false;
        $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null);
        this.markers.splice(index, 1); // Remove the marker from the list of managed markers
        if (!noDraw) this.render();
        return true;
    }
    removeMarkers(markers, noDraw) {
        let removed = false;
        markers.forEach((marker)=>{
            removed = this.removeMarker(marker, true) || removed;
        });
        if (removed && !noDraw) this.render();
        return removed;
    }
    clearMarkers(noDraw) {
        this.markers.length = 0;
        if (!noDraw) this.render();
    }
    /**
     * Recalculates and draws all the marker clusters.
     */ render() {
        const map = this.getMap();
        if (map instanceof google.maps.Map && map.getProjection()) {
            google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTERING_BEGIN, this);
            const { clusters: clusters, changed: changed } = this.algorithm.calculate({
                markers: this.markers,
                map: map,
                mapCanvasProjection: this.getProjection()
            });
            // Allow algorithms to return flag on whether the clusters/markers have changed.
            if (changed || changed == undefined) {
                // Accumulate the markers of the clusters composed of a single marker.
                // Those clusters directly use the marker.
                // Clusters with more than one markers use a group marker generated by a renderer.
                const singleMarker = new Set();
                for (const cluster of clusters)if (cluster.markers.length == 1) singleMarker.add(cluster.markers[0]);
                const groupMarkers = [];
                // Iterate the clusters that are currently rendered.
                for (const cluster of this.clusters){
                    if (cluster.marker == null) continue;
                    if (cluster.markers.length == 1) {
                        if (!singleMarker.has(cluster.marker)) // The marker:
                        // - was previously rendered because it is from a cluster with 1 marker,
                        // - should no more be rendered as it is not in singleMarker.
                        $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(cluster.marker, null);
                    } else // Delay the removal of old group markers to avoid flickering.
                    groupMarkers.push(cluster.marker);
                }
                this.clusters = clusters;
                this.renderClusters();
                // Delayed removal of the markers of the former groups.
                requestAnimationFrame(()=>groupMarkers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null)));
            }
            google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTERING_END, this);
        }
    }
    onAdd() {
        this.idleListener = this.getMap().addListener("idle", this.render.bind(this));
        this.render();
    }
    onRemove() {
        google.maps.event.removeListener(this.idleListener);
        this.reset();
    }
    reset() {
        this.markers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null));
        this.clusters.forEach((cluster)=>cluster.delete());
        this.clusters = [];
    }
    renderClusters() {
        // Generate stats to pass to renderers.
        const stats = new $b91f9f2fdb98b359$export$2deda6e6beba3286(this.markers, this.clusters);
        const map = this.getMap();
        this.clusters.forEach((cluster)=>{
            if (cluster.markers.length === 1) cluster.marker = cluster.markers[0];
            else {
                // Generate the marker to represent the group.
                cluster.marker = this.renderer.render(cluster, stats, map);
                // Make sure all individual markers are removed from the map.
                cluster.markers.forEach((marker)=>$b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(marker, null));
                if (this.onClusterClick) cluster.marker.addListener("click", /* istanbul ignore next */ (event)=>{
                    google.maps.event.trigger(this, $b91f9f2fdb98b359$export$f87b0506a2cf0bc.CLUSTER_CLICK, cluster);
                    this.onClusterClick(event, cluster, map);
                });
            }
            $b91f9f2fdb98b359$export$87c23728007fa1bd.setMap(cluster.marker, map);
        });
    }
}


class $61e4840a329ce68d$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".map-element-disabled"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @type {google.maps.Map} */ #map;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        const mapElement = this.#holderElement.querySelector(".map");
        const hiddenPlaces = this.#holderElement.querySelector(".hidden-places-list").querySelectorAll(".hidden-place");
        let center = {
            lat: -27.467534295350724,
            lng: 153.02410529597566
        };
        const mapOptions = {
            zoom: 8,
            maxZoom: 15,
            center: center,
            styles: [
                {
                    "featureType": "landscape.man_made",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#faf5ed"
                        },
                        {
                            "lightness": "0"
                        },
                        {
                            "gamma": "1"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#bae5a6"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "weight": "1.00"
                        },
                        {
                            "gamma": "1.8"
                        },
                        {
                            "saturation": "0"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "hue": "#ffb200"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "lightness": "0"
                        },
                        {
                            "gamma": "1"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.airport",
                    "elementType": "all",
                    "stylers": [
                        {
                            "hue": "#b000ff"
                        },
                        {
                            "saturation": "23"
                        },
                        {
                            "lightness": "-4"
                        },
                        {
                            "gamma": "0.80"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#a0daf2"
                        }
                    ]
                }
            ],
            disableDefaultUI: true
        };
        const loader = new (0, $57fb306f6b148ac8$export$3b0d6d7590275603)({
            apiKey: window.config.googleMapsApiKey,
            version: "weekly"
        });
        loader.importLibrary("maps").then(({ Map: Map })=>{
            this.#map = new Map(mapElement, mapOptions);
            return this.#setMarkers(loader, hiddenPlaces);
        });
    }
    /**
	 * @param {Loader} loader
	 * @param {NodeListOf<Element>} hiddenPlaces
	 */ async #setMarkers(loader, hiddenPlaces) {
        const { LatLngBounds: LatLngBounds } = await loader.importLibrary("core");
        const { Marker: Marker } = await loader.importLibrary("marker");
        await window.loadScript("snazzyInfoWindow");
        await window.loadScript("mapCluster");
        const bounds = new LatLngBounds();
        let map = this.#map;
        let markers = [];
        let categoriesMarkersList = [];
        categoriesMarkersList["category-all"] = [];
        const algorithmOptions = {
            maxZoom: 10
        };
        const renderer = {
            render: ({ count: count, position: position })=>new google.maps.Marker({
                    label: {
                        text: String(count),
                        color: "#fff",
                        fontSize: "18px",
                        fontWeight: "normal",
                        textAlign: "center",
                        width: "54",
                        height: "54"
                    },
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($af8087a36eec0f8c$exports))),
                    position: position,
                    map: map,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                    styles: [
                        {
                            anchorText: [
                                2,
                                22
                            ]
                        }
                    ]
                })
        };
        hiddenPlaces.forEach((place)=>{
            const location = {
                lat: parseFloat(place.dataset.latitude),
                lng: parseFloat(place.dataset.longitude)
            };
            bounds.extend(location);
            let marker = new Marker({
                position: location,
                map: map,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($3675200c0516c75b$exports))),
                title: place.dataset.title
            });
            new SnazzyInfoWindow({
                marker: marker,
                content: this.#getMarkerContent(place),
                closeWhenOthersOpen: true
            });
            place.dataset.categories.split(",").forEach((category)=>{
                if (category !== "") {
                    if (categoriesMarkersList[category] === undefined) categoriesMarkersList[category] = [];
                    categoriesMarkersList[category].push(marker);
                }
            });
            categoriesMarkersList["category-all"].push(marker);
            markers.push(marker);
        });
        this.#holderElement.querySelectorAll(".category").forEach((category)=>{
            category.addEventListener("click", ()=>{
                const filteredBounds = new LatLngBounds();
                this.#holderElement.querySelector(".current").classList.remove("current");
                category.classList.add("current");
                let selectedCategoryID = category.dataset.category;
                if (categoriesMarkersList[selectedCategoryID]) {
                    markers.forEach((marker)=>{
                        if (categoriesMarkersList[selectedCategoryID].indexOf(marker) > -1) {
                            marker.setVisible(true);
                            filteredBounds.extend(marker.getPosition());
                        } else marker.setVisible(false);
                    });
                    map.fitBounds(filteredBounds);
                } else {
                    markers.forEach((marker)=>{
                        marker.setVisible(false);
                    });
                    map.fitBounds(bounds);
                }
            });
        });
        map.fitBounds(bounds);
        new (0, $b91f9f2fdb98b359$export$58bd9bb9fcf3dd4f)({
            map: map,
            markers: markers,
            algorithmOptions: algorithmOptions,
            renderer: renderer
        });
    }
    /**
	 * @param {Element} place
	 * @return {string}
	 */ #getMarkerContent(place) {
        const content = [];
        content.push('<div class="row marker-content">');
        content.push('<div class="col marker-snazzy-info">');
        content.push("<h6>");
        content.push(place.dataset.title);
        content.push(`</h6>`);
        place.dataset.address && content.push("<p>" + place.dataset.address + "</p>");
        place.dataset.link && content.push('<a href="' + place.dataset.link + '" target="_blank">');
        place.dataset.link && content.push(`Get directions`);
        place.dataset.link && content.push(`</a>`);
        content.push(`</div>`);
        content.push(`</div>`);
        return content.join("");
    }
}


class $d2ef8d3490be9980$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".gallery-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        GLightbox({
            touchNavigation: true,
            loop: false,
            autoplayVideos: false
        });
    }
}


class $f9f01845c0e43ef5$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".rooms-element"
        ];
    /** @type {HTMLElement} */ #holderElement;
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        this.#holderElement = holderElement;
        const sliderElement = holderElement.querySelector(".splide");
        if (sliderElement) {
            const slider = new Splide(sliderElement, {
                type: "loop",
                perPage: 3,
                perMove: 1,
                gap: "2rem",
                pagination: false,
                arrows: false,
                breakpoints: {
                    768: {
                        perPage: 1
                    },
                    960: {
                        perPage: 2
                    }
                }
            });
            slider.mount();
            const sliderControls = holderElement.querySelectorAll("[data-slider-control]");
            sliderControls.forEach((sliderControl)=>{
                sliderControl.addEventListener("click", ()=>{
                    slider.go(sliderControl.dataset.sliderControl);
                });
            });
        }
    }
}


class $cffcb36afb035411$export$2e2bcd8739ae039 {
    static getHolderSelectors = ()=>[
            ".room-element"
        ];
    /** @param {HTMLElement} holderElement */ constructor(holderElement){
        const features = holderElement.querySelector(".features");
        if (features) {
            const featuresObserver = new IntersectionObserver((entries)=>{
                if (!entries[0].isIntersecting) return;
                features.classList.add("scrolled");
                featuresObserver.disconnect();
            });
            featuresObserver.observe(features);
        }
        const headerPosition = document.querySelector(".header-position-holder");
        headerPosition.classList.add("d-none");
        const header = document.querySelector("header");
        header.classList.add("unpinned");
        let pinned = false;
        const navObserver = new IntersectionObserver((entry)=>{
            if (entry[0].isIntersecting && pinned) {
                holderElement.classList.remove("pinned");
                pinned = false;
            } else if (!entry[0].isIntersecting && !pinned) {
                holderElement.classList.add("pinned");
                pinned = true;
            }
        });
        navObserver.observe(header);
        const gallery = holderElement.querySelector(".gallery");
        if (gallery) GLightbox({
            touchNavigation: true,
            loop: false,
            autoplayVideos: false
        });
    }
}


const $f588187e97d40c34$var$modules = [
    (0, $b5900b0d33e64e2a$export$2e2bcd8739ae039),
    (0, $02951e8ab9437aa9$export$2e2bcd8739ae039),
    (0, $125566076e2f0cd4$export$2e2bcd8739ae039),
    (0, $30d05a3b7b2a050e$export$2e2bcd8739ae039),
    (0, $4712496a6aa399de$export$2e2bcd8739ae039),
    (0, $93c45a678ea1b005$export$2e2bcd8739ae039),
    (0, $85144a7bc83ca709$export$2e2bcd8739ae039),
    (0, $61e4840a329ce68d$export$2e2bcd8739ae039),
    (0, $d2ef8d3490be9980$export$2e2bcd8739ae039),
    (0, $f9f01845c0e43ef5$export$2e2bcd8739ae039),
    (0, $cffcb36afb035411$export$2e2bcd8739ae039)
];
new (0, $90df0591fe51bcf3$export$2e2bcd8739ae039)($f588187e97d40c34$var$modules);

})();
//# sourceMappingURL=main.js.map
